import {
    ChangeDetectionStrategy,
    Component,
    ContentChild,
    Input,
    TemplateRef,
    ViewEncapsulation,
} from '@angular/core';

export interface IInfoCardEntry {
    title: string;
    info: number | Date | string;
}

@Component({
    selector: 'ui-info-card',
    templateUrl: 'ui-info-card.component.html',
    styleUrls: ['./ui-info-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class UiInfoCardComponent {
    @ContentChild(TemplateRef, { static: true })
    public contentTemplate!: TemplateRef<any>;

    @Input()
    public entries?: IInfoCardEntry[];

    @Input()
    public direction: 'vertical' | 'horizontal' = 'vertical';

    public get isCompactView() {
        return this.entries && this.entries.length > 4;
    }

    public get isOdd() {
        return this.entries!.length % 2 === 1;
    }

    public get hasSibling() {
        return this.entries!.length > 1;
    }

    public isFirst(index: number) {
        return index === 0;
    }

    public isRightSide(index: number) {
        if (this.isOdd) {
            return index % 2 === 0;
        }

        return index % 2 !== 0;
    }
}
